import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './layout/home/home.component';
import { LoginComponent } from 'sce-home';

import { RootAuthGuard } from './guards/root-auth.guard';
import { OnlyLoggedInUsersGuard } from './guards/only-loggedin-users.guard';
import { AlwaysAuthChildrenGuard } from './guards/always-auth-children.guard';
import { CountryBasedRedirectionGuard } from 'sce-core';

@NgModule({
  imports: [
    RouterModule.forRoot([
      /* Define app module routes here, e.g., to lazily load a module
         (Never place feature module routes here, use an own -routing.module.ts in the feature instead) */
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      {
        path: 'home', component: HomeComponent,
        canActivate: [RootAuthGuard, OnlyLoggedInUsersGuard, CountryBasedRedirectionGuard],
        canActivateChild: [AlwaysAuthChildrenGuard],
        // canDeactivate : [ DeactivateGuard ],
        children: [
          { path: 'admin', loadChildren: './features/admin/admin-wrapper.module#SCEAdminModuleLazyLoadWrapper' },
          { path: 'inbound', loadChildren: './features/inbound/inbound.module#InboundModule' },
          { path: 'outbound', loadChildren: './features/outbound/outbound.module#OutboundModule' },
          { path: 'reports', loadChildren: './features/reports/reports.module#ReportsModule' },
          { path: 'inventory', loadChildren: './features/inventory/inventory.module#InventoryModule' },
          { path: 'setup', loadChildren: './features/setup/setup.module#SetupModule' },
          { path: 'system', loadChildren: './features/system/system.module#SystemModule' },
          { path: 'control', loadChildren: './features/control/control.module#ControlModule' },
          { path: 'global-control', loadChildren: './features/global-control/global-control.module#GlobalControlModule' },
          { path: 'config-wizard', loadChildren: './features/config-wizard/config-wizard.module#ConfigWizardModule' }

        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/app-routing.module.ts